export const loaderStyle = {
    height: "calc(100vh - 200px)"
  };
